<p-panelMenu
  [model]="(menuItems$ | async) ?? []"
  [style]="{ background: 'transparent' }"
  styleClass="bg-transparent border-none"
>
  <ng-template #item let-item>
    <a
      [routerLink]="item.route"
      class="flex items-center px-4 py-2 cursor-pointer group h-12 hover:bg-background-50 rounded"
      [ngClass]="{
        '!bg-background-100':
          item.hasActiveChild ??
          (item.active && !item.hasActiveChild && !item.parent),
      }"
    >
      @if (item.icon && !item.parent) {
        <i class="material-symbols-outlined">{{ item.icon }}</i>
      }

      @if (item.parent) {
        <div class="w-6 h-6 flex items-center justify-center">
          @if (item.active) {
            <div class="w-2 h-2 rounded-full bg-text-700"></div>
          }
        </div>
      }

      <span
        class="ml-2 font-medium text-text-700 text-sm"
        [ngClass]="{
          '!font-bold': item.active || item.hasActiveChild,
          '!text-text-500': item.parent && !item.active,
        }"
      >
        {{ item.label }}
      </span>

      @if (item.items?.length) {
        <i
          class="material-symbols-outlined ml-auto transition-transform duration-200"
          [ngClass]="{ 'rotate-180': item.expanded }"
        >
          keyboard_arrow_down
        </i>
      }
    </a>
  </ng-template>
</p-panelMenu>
